import React, { Component } from "react";
import axios from "axios";
import $ from "jquery";
import Headers from "../Layouts/Headers";
import { config } from "../_helpers/global";
import { MDBDataTable } from "../_mdbcomponents/components/DataTable/DataTable";
import Loader from "../Layouts/Loader";
import { InterModularSidebar } from "../Layouts/InterModularSidebar";

export class EditDetails extends Component {
  constructor(props) {
    super(props);

   

    const url = "";

    this.state = {
      FirstActivityAge: "",
      NumberOfPartners: "",
      AssaultOrAbuseHistory: "",
      allModuleData: "",
    };

    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    //this.PrintWindow = this.PrintWindow.bind(this);
  }

  componentDidMount() {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("patientVisitId"),
      // 'visitid': localStorage.getItem('visitId')
    };

    $("body").on("change", "input", ".inputField", function (event) {
      event.preventDefault();
      // alert('dkfdkfkdfk')
      console.log(event.target.value);

      var id = $(this).attr("id");

      axios
        .get(this.url + "/alldata/get/allvalues", { headers: headers })
        .then((res) => {
          var allModuleData = res.data["data"];

          var objectKeys = Object.keys(
            allModuleData[localStorage.getItem("editdetailId")][0]
          );

          var VallueInputted = new Object();
          for (
            var i = 0;
            i <
            Object.keys(allModuleData[localStorage.getItem("editdetailId")][0])
              .length;
            i++
          ) {
            VallueInputted[objectKeys[i]] = event.target.value;
          }

          //   console.log(VallueInputted)
          $(".dataEnetered").attr("text", VallueInputted);

          localStorage.setItem("valueInput", JSON.stringify(VallueInputted));
        });
    });

    //

    // console.log(localStorage.getItem('patientVisitId'))
    axios
      .get(this.url + "/alldata/get/allvalues", { headers: headers })
      .then((res) => {
        var allModuleData = res.data["data"];

        var objectKeys = Object.keys(
          allModuleData[localStorage.getItem("editdetailId")][0]
        );
        var objectValues = new Object();

        for (
          var i = 0;
          i <
          Object.keys(allModuleData[localStorage.getItem("editdetailId")][0])
            .length;
          i++
        ) {
          if (
            Object.keys(allModuleData[localStorage.getItem("editdetailId")][0])[
              i
            ] !== "_id"
          ) {
            $(".formSpace").append(div);
            objectValues[objectKeys[i]] =
              allModuleData[localStorage.getItem("editdetailId")][0][
                objectKeys[i]
              ];

            if (
              Object.keys(
                allModuleData[localStorage.getItem("editdetailId")][0]
              )[i] !== "visitid" &&
              Object.keys(
                allModuleData[localStorage.getItem("editdetailId")][0]
              )[i] !== "chiefstatus" &&
              Object.keys(
                allModuleData[localStorage.getItem("editdetailId")][0]
              )[i] !== "module"
            ) {
              var div =
                '<div className="py-1"> <h6 className="text-capitalize" style={fontFamilyNunito}>' +
                objectKeys[i] +
                '</h6><input className="form-control inputField"  id=' +
                objectKeys[i] +
                " value=" +
                allModuleData[localStorage.getItem("editdetailId")][0][
                  objectKeys[i]
                ] +
                " name=" +
                objectKeys[i] +
                ' type="text" required /> </div>';
            }
          }
        }
        this.setState({
          allModuleData: objectValues,
        });
      });
  }

  handleChange(event) {}

  PrintWindow(event) {
    document.title =
      localStorage.getItem("currentVisitName") + "`s " + this.constructor.name;
    $(".modal").hide();
    window.print();
  }

  handleSubmit = (event) => {
    const headers = {
      "Content-Type": "application/json",
      token: localStorage.getItem("accessToken"),
      visitid: localStorage.getItem("currentVisitId"),
    };
    event.preventDefault();

    axios
      .post(
        this.api_url+"alldata/update/" + localStorage.getItem("editdetailId"),
        JSON.parse(localStorage.getItem("valueInput")),
        { headers: headers }
      )
      .then((response) => {
        console.log(response);

        if (response.data["status"]) {
          $(".alert-success").show();
          setTimeout(function () {
            // window.location.href = '/gynecology/prior/gyn/infection'
          }, 500);
        }
      })
      .catch((error) => {
        console.log(error);
        $('#SubmitError').show();
        $(".alert-success").hide();
      });
  };

  render() {
    const font16 = { fontSize: "16px" };
    const fontFamilyNunito = { fontFamily: "Nunito, sans-serif" };
    const floatRight = { float: "right;" };
    const floatLeft = { float: "left;" };
    const displayHidden = { display: "none" };

    const { FirstActivityAge, NumberOfPartners, AssaultOrAbuseHistory } =
      this.state;

    const editdetailId = localStorage.getItem("editdetailId");
    return (
      <div>
        <Headers />
        <InterModularSidebar />
        <p className="dataEnetered"></p>

        <main className="content-container ">
          <div className="container p-2">
            <form onSubmit={this.handleSubmit}>
              <div className="form-row pt-4 formSpace">
                <div className="col-md-12 text-lg-center font-weight-bold p-1">
                  <p className="text-capitalize" style={font16}>
                    Edit Details {editdetailId}
                  </p>
                </div>
              </div>

              <div
                id="loginSuccess"
                className="alert alert-success"
                style={displayHidden}
                role="alert"
              >
                <strong>Success! </strong>
                {editdetailId} Details Saved Successfully.
              </div>

              <div className="row">
                {/* <div style={displayHidden} className="col col-6"><button className="btn btn-primary btn-warning rounded-pill px-4 font-weight-bold" type="button" style={floatRight}>Send To Triage</button></div> */}
                <div className="col col-6">
                  <button
                    className="btn btn-primary btn-warning rounded-pill px-5 font-weight-bold"
                    type="submit"
                    style={floatLeft}
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </main>
      </div>
    );
  }
}

export default EditDetails;
